import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const getTelecoms = params => {
  return ApiService.query(`mobile/telecoms?${stringify(params)}`);
};

export const getCategory = params => {
  return ApiService.query(`mobile/devices/categories/${params.id}`);
};

export const getDevice = params => {
  return ApiService.query(`mobile/devices?${stringify(params)}`);
};

export const getDeviceDetail = params => {
  return ApiService.query(`mobile/devices/${params.id}`);
};

export const getPlanCategory = params => {
  return ApiService.query(`mobile/plans/categories?${stringify(params)}`);
};

export const getPlans = params => {
  return ApiService.query(`mobile/plans?${stringify(params)}`);
};

export const getPlanDetail = params => {
  return ApiService.query(`mobile/plans/${params.id}?${stringify(params)}`);
};

export const setRequests = params => {
  return ApiService.post(`mobile/requests`, params);
};

export const getMobileCoupon = params => {
  return ApiService.query(`mobile/coupon`);
};

export const getRequestList = params => {
  return ApiService.query(`mobile/requests?${stringify(params)}`);
};

export const getRequestView = params => {
  return ApiService.query(`mobile/requests/${params.id}?${stringify(params)}`);
};

export const setRequestClose = params => {
  return ApiService.put(`mobile/requests/${params.id}/close`);
};

export const getEstimateList = params => {
  return ApiService.query(`mobile/estimates?${stringify(params)}`);
};

export const getEstimateGroupList = params => {
  return ApiService.query(`mobile/estimateGroups?${stringify(params)}`);
};

export const setPlanUpdate = params => {
  return ApiService.put(
    `mobile/requests/plan/${params.id}?${stringify(params)}`,
  );
};

export const getServiceList = params => {
  return ApiService.query(`mobile/services?${stringify(params)}`);
};

export const setEstimates = params => {
  return ApiService.post(`mobile/estimates`, params);
};

export const preViewEstimates = params => {
  return ApiService.post(`mobile/estimates/preView`, params);
};

export const getEstimateDetail = params => {
  return ApiService.query(`mobile/estimates/${params.id}?${stringify(params)}`);
};

export const setPromise = params => {
  return ApiService.post(`promise/visitPromises`, params);
};

export const getPromise = params => {
  return ApiService.query(
    `promise/visitPromises/${params.id}?${stringify(params)}`,
  );
};

export const getPromiseList = params => {
  return ApiService.query(`promise/visitPromises?${stringify(params)}`);
};

export const getEstimateNewCnt = params => {
  return ApiService.query(`mobile/estimates/unread?${stringify(params)}`, {
    isLoading: false,
  });
};

export const setEstimateVisible = params => {
  return ApiService.put(
    `mobile/estimates/visible/${params.id}?${stringify(params)}`,
  );
};

export const getPromiseNewCnt = params => {
  return ApiService.query(
    `promise/visitPromises/unreadCnt?${stringify(params)}`,
  );
};

export const getInsuranceList = params => {
  return ApiService.query(`mobile/insurances?${stringify(params)}`);
};

export const getMobileProducts = params => {
  return ApiService.query(`mobile/products?${stringify(params)}`);
};

export const setBookmark = params => {
  return ApiService.put(`mobile/products/bookmarks?${stringify(params)}`);
};

export const setViewProductCnt = params => {
  return ApiService.put(`mobile/products/view?${stringify(params)}`);
};

export const setSelProductCnt = params => {
  return ApiService.put(`mobile/products/sel?${stringify(params)}`);
};

export const getMobileRequestCnt = params => {
  return ApiService.query(`mobile/requestCount?${stringify(params)}`);
};

export const setApplyOnline = params => {
  return ApiService.post(`mobile/applies`, params);
};

export const setApplyVisit = params => {
  return ApiService.post(`mobile/promises`, params);
};

export const getApplyList = params => {
  return ApiService.query(`mobile/applies?${stringify(params)}`);
};

export const getApplyDetail = params => {
  return ApiService.query(`mobile/applies/${params.id}?${stringify(params)}`);
};

export const getChatEstimateList = params => {
  return ApiService.query(
    `mobile/estimates/chat/${params.chatroomId}?${stringify(params)}`,
  );
};

export const getApplyStatus = params => {
  return ApiService.query(
    `mobile/applies/${params.id}/status?${stringify(params)}`,
  );
};

export const setApplyCancel = params => {
  return ApiService.post(`mobile/applies/${params.id}/cancel`);
};

export const getApplyNewCnt = params => {
  return ApiService.query(`mobile/applies/cntNew?${stringify(params)}`);
};

export const setItemBookmark = params => {
  return ApiService.put(`mobile/items/bookmarks?${stringify(params)}`);
};

export const getMobileDeal = params => {
  return ApiService.query(`mobile/deals?${stringify(params)}`);
};

export const getMobileDealDetail = params => {
  return ApiService.query(`mobile/deals/${params.id}?${stringify(params)}`);
};

export const mobileDealChat = params => {
  return ApiService.post(`mobile/deals/${params.id}/chat`, params);
};

export const getMobileEstimateRecent = params => {
  return ApiService.query(`mobile/estimates/recent?${stringify(params)}`);
};

export const getMobileRequestSameCnt = params => {
  return ApiService.query(`mobile/requests/sameCount?${stringify(params)}`);
};
